module.exports = "<div data-component=\"deposit-confirmation\" class=\"step\" *ngIf=\"active\">\n\n\t<app-list-confirmation [list]=\"confirmList\" justList=\"true\"></app-list-confirmation>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-confirmation/deposit-confirmation.component.html
// module id = ../../../../../src/app/master/deposit-per-ticket/deposit-confirmation/deposit-confirmation.component.html
// module chunks = main